<template>
  <div>
    <b-row class="mt-5 mb-3">
      <b-col sm="12" md="6">
        <h2>Vos délibérations</h2>
      </b-col>
      <b-col>
        <b-button
          variant="link"
          class="float-lg-right mr-2 px-1"
          v-b-modal.modal-1
        >
          <b-icon
            font-scale="1.1"
            icon="info-circle-fill"
            variant="primary"
          ></b-icon>
          Comment ajouter une délibération a votre compte
        </b-button>
      </b-col>
    </b-row>
    <b-row class="my-4" v-if="isTeacher">
      <b-col sm="12" md="6" class="text-right">
        <b-btn
          :to="{ name: 'teachers.create.deliberations' }"
          pill
          variant="info"
          class="text-white add-user"
        >
          <BIconPlus></BIconPlus>
          <span>Créer une nouvelle délibération</span>
        </b-btn>
      </b-col>
    </b-row>
    <b-card no-body class="bg-primary text-center" v-if="isTeacher">
      <div class="text-center pt-3">
        <p class="text-white">Mes déliberations ( {{ dlibrList.length }} )</p>
      </div>
    </b-card>
    <template v-if="isBusy">
      <b-card class="my-5">
        <div class="text-center">
          <b-spinner></b-spinner>
          <p>Actualisation en cours...</p>
        </div>
      </b-card>
    </template>
    <template v-if="!isBusy">
      <div role="tablist">
        <b-card no-body class="mb-1" v-for="dlibr in dlibrList" :key="dlibr.id">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              v-b-toggle="`accordion-${dlibr.id}`"
              variant="none"
              class="text-left  dlibr-collapse-unit toggle-trigger"
            >
              <b-icon
                class="mr-2"
                icon="chevron-right"
                variant="primary"
              ></b-icon
              >{{ dlibr.title }} - {{ dlibr.description }}<br />
              <small>{{ urlPreview(dlibr) }}</small></b-button
            >
          </b-card-header>
          <b-collapse
            :id="`accordion-${dlibr.id}`"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card-text v-if="isTeacher">
                <b-row cols="2" class="text-center">
                  <b-col>
                    <b-icon
                      icon="people-fill"
                      variant="secondary"
                      font-scale="1.5"
                    ></b-icon>
                    {{ dlibr.total_participants }}
                  </b-col>
                  <b-col>
                    <b-icon
                      icon="chat-fill"
                      variant="secondary"
                      font-scale="1.5"
                    ></b-icon>
                    {{ dlibr.total_comments }}
                  </b-col>
                </b-row>
              </b-card-text>
              <b-card-text>
                <i>Depuis votre dernière connexion</i>
              </b-card-text>
              <div class="p-2">
                <b-card-text>
                  <b-button
                    variant="none"
                    block
                    class="text-left"
                    :disabled="
                      !Boolean(dlibr.all_last_comments.length) ||
                        isSuspend(dlibr)
                    "
                    @click="
                      emitShowLastConnection({
                        id: dlibr.id,
                        data: dlibr.all_last_comments,
                        title: 'Nouvelles publications'
                      })
                    "
                  >
                    <b-icon
                      icon="chat-fill"
                      variant="secondary"
                      class="mr-2"
                      font-scale="1.5"
                    ></b-icon>
                    {{ dlibr.all_last_comments.length }} nouvelles publications
                  </b-button>
                </b-card-text>
                <b-card-text>
                  <b-button
                    variant="none"
                    block
                    class="text-left"
                    :disabled="
                      !Boolean(dlibr.last_comment_replies.length) ||
                        isSuspend(dlibr)
                    "
                    @click="
                      emitShowLastConnection({
                        id: dlibr.id,
                        data: dlibr.last_comment_replies,
                        title: 'Nouvelles discussions'
                      })
                    "
                  >
                    <b-iconstack class="mr-2" font-scale="1.5">
                      <b-icon
                        stacked
                        icon="chat-fill"
                        variant="secondary"
                        class="mr-2"
                      ></b-icon>
                      <b-icon
                        stacked
                        icon="chat"
                        variant="secondary"
                        shift-h="3"
                        shift-v="-1"
                        flip-h
                      ></b-icon>
                    </b-iconstack>
                    {{ dlibr.last_comment_replies.length }} nouvelles
                    discussions
                  </b-button>
                </b-card-text>
                <b-card-text>
                  <b-button
                    variant="none"
                    block
                    class="text-left"
                    :disabled="
                      !Boolean(dlibr.my_last_comment_replies.length) ||
                        isSuspend(dlibr)
                    "
                    @click="
                      emitShowLastConnection({
                        id: dlibr.id,
                        data: dlibr.my_last_comment_replies,
                        title:
                          'Nouvelles discussions depuis une de vos publication'
                      })
                    "
                  >
                    <b-iconstack class="mr-2" font-scale="1.5">
                      <b-icon
                        stacked
                        icon="chat-fill"
                        variant="secondary"
                        class="mr-2"
                      ></b-icon>
                      <b-icon
                        stacked
                        icon="chat"
                        variant="secondary"
                        shift-h="3"
                        shift-v="-1"
                        flip-h
                      ></b-icon>
                    </b-iconstack>
                    {{ dlibr.my_last_comment_replies.length }} nouvelles
                    discussions depuis une de vos publication
                  </b-button>
                </b-card-text>
                <b-card-text>
                  <b-button
                    variant="none"
                    block
                    class="text-left"
                    :disabled="
                      !Boolean(dlibr.total_comments_flagged.length) ||
                        isSuspend(dlibr)
                    "
                    @click="
                      goToFlagged({
                        id: dlibr.id,
                        teacher: dlibr.teacher.id,
                        url: dlibr.url
                      })
                    "
                  >
                    <span class="text-warning">
                      <BIconFlagFill font-scale="1.5"></BIconFlagFill>
                    </span>
                    {{
                      dlibr.total_comments_flagged.length +
                        dlibr.total_flagged_messages.length
                    }}
                    Publication à modifier
                  </b-button>
                </b-card-text>
                <b-card-text>
                  <b-button
                    variant="none"
                    block
                    class="text-left"
                    :disabled="
                      !Boolean(dlibr.total_messages.length) || isSuspend(dlibr)
                    "
                    @click="
                      emitShowLastConnection({
                        id: dlibr.id,
                        data: dlibr.total_messages,
                        title: textMsgs
                      })
                    "
                  >
                    <span class="text-warning">
                      <b-icon
                        icon="envelope-fill"
                        variant="info"
                        font-scale="1.5"
                      ></b-icon>
                    </span>
                    {{ dlibr.total_messages.length }} {{ textMsgs }}
                  </b-button>
                </b-card-text>
                <b-card-text class=" p-1 text-center">
                  <b-button
                    v-if="isTeacher"
                    variant="link"
                    class="mb-3"
                    pill
                    :to="{
                      name: 'teacher.edit.deliberation',
                      params: { id: dlibr.id }
                    }"
                    >Modifier la délibération</b-button
                  >
                  <br />
                  <b-button
                    variant="outline-primary"
                    :disabled="allBtnDisabled"
                    pill
                    @click="goToDlibr(dlibr)"
                    >Voir la délibération
                    <b-spinner
                      class="text-secondary"
                      small
                      v-if="buttonsLoading[dlibr.teacher.id]"
                    />
                  </b-button>
                </b-card-text>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </template>
    <div>
      <b-modal id="modal-1" title="" size="lg">
        <b-container class="text-center">
          <b-icon
            class="mt-3"
            font-scale="3.1"
            icon="info-circle-fill"
            variant="primary"
          ></b-icon>
          <h5 class="mt-4">Comment ajouter une délibération à votre compte.</h5>
          <br />
          <p>
            Veuillez tout simplement cliquer sur le lien URL d'une délibération
            que vous avez été invité à joindre. Généralement, cette invitation
            est envoyée par votre enseignant via courriel.
            <br /><br />
          </p>
          <p class="text-secondary">
            Le URL ressemblera à ceci : <br />
            https://dlibr.ccdmd.qc.ca/nom de la délibération
          </p>
        </b-container>
        <template v-slot:modal-footer="{ cancel }">
          <div class="w-100">
            <b-button
              variant="primary"
              pill
              class="float-right"
              @click="cancel()"
            >
              Fermer
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
/**
 * @file       Deliberation mobile component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import Vue from "vue";
import { mapState } from "vuex";
import { dlibrsMixin } from "@/modules/deliberations/mixins";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "dlibrsMobile",
  mixins: [dlibrsMixin],

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      buttonsLoading: [],
      allBtnDisabled: false
    };
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      participantDlibr: state => state.deliberations.participantDlibr,
      teacherDlibr: state => state.deliberations.teacherDlibr
    }),

    /**
     * Check if the status of deliberations is busy.
     *
     * @return     {bool}  Busy or not.
     */
    isBusy() {
      return (
        this.participantDlibr.status === "fetching" ||
        this.teacherDlibr.status === "fetching"
      );
    },
    dlibrList() {
      return this.isStudent
        ? this.participantDlibr.data.data
        : this.teacherDlibr.data.data;
    },
    textMsgs() {
      return this.isStudent
        ? "Nouveau message de votre enseignant"
        : "Message(s)";
    }
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    emitShowLastConnection(data) {
      this.$emit("showLastConnection", data);
    },
    goToDlibr(dlibr) {
      if (
        this.isStudent &&
        dlibr.group.students.find(d => d).pivot.status == 3
      ) {
        this.$root.$bvToast.toast(
          "Vous n'êtes pas autorisé à accéder à cette délibération",
          {
            title: "Erreur",
            variant: "danger"
          }
        );
      } else {
        Vue.set(this.buttonsLoading, dlibr.teacher.id, true);
        this.allBtnDisabled = true;
        this.$router.push({
          name: "deliberation.byUrl",
          params: {
            teacher: dlibr.teacher.id,
            url: dlibr.url
          }
        });
      }
    },
    isSuspend(dlibr) {
      return (
        this.isStudent && dlibr.group.students.find(d => d).pivot.status == 3
      );
    },
    urlPreview(item) {
      return `${window.location.origin}/#/${item.teacher.id}/${item.url}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.toggle-trigger[aria-expanded="true"] .bi-chevron-right {
  transform: rotate(90deg);
}
.toggle-trigger .bi-chevron-right {
  transition: 0.3s transform ease-in-out;
}
</style>
